/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rate plan entity
 * @export
 * @interface TravelineBookingRatePlanRqDto
 */
export interface TravelineBookingRatePlanRqDto {
    /**
     * Rate plan ID
     * @type {string}
     * @memberof TravelineBookingRatePlanRqDto
     */
    id: string;
}

/**
 * Check if a given object implements the TravelineBookingRatePlanRqDto interface.
 */
export function instanceOfTravelineBookingRatePlanRqDto(value: object): value is TravelineBookingRatePlanRqDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineBookingRatePlanRqDtoFromJSON(json: any): TravelineBookingRatePlanRqDto {
    return TravelineBookingRatePlanRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingRatePlanRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRatePlanRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

  export function TravelineBookingRatePlanRqDtoToJSON(json: any): TravelineBookingRatePlanRqDto {
      return TravelineBookingRatePlanRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRatePlanRqDtoToJSONTyped(value?: TravelineBookingRatePlanRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

